import loadable from '@loadable/component';

const MyModuleListPage = loadable(() => import('./page'));
const MyModulePage = loadable(() => import('./[id]/form'));

export const routes = [
  {
    path: '',
    element: <MyModuleListPage />,
  },
  {
    path: ':id',
    element: <MyModulePage />,
  },
];
